// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"279":"61094f95","717":"e5a7301e"}[chunkId] + ".chunk.css";
};